/* ================================================== */
/* FLUID EMBEDS
/* ================================================== */

$(function() {
	var $fluidElements = $('.embed, .video-container');
	
	$fluidElements.each(function(){
		var $figure = $(this);
		var $objs   = $figure.find('iframe[src^="http://player.vimeo.com"], iframe[src^="http://www.youtube.com"], object, embed, iframe');
		$objs.each(function(){
			var $obj = $(this);
			$obj.attr('data-aspectRatio', this.height / this.width).removeAttr('height').removeAttr('width');
		});
	});
	
	$(window).resize(function() {
		$fluidElements.each(function(){
			var $figure   = $(this);
			var new_width = $figure.width();
			var $objs     = $figure.find('iframe[src^="http://player.vimeo.com"], iframe[src^="http://www.youtube.com"], object, embed, iframe');
			$objs.each(function(){
				var $obj = $(this);
				$obj.width(new_width).height(new_width * $obj.attr('data-aspectRatio'));
			});
		});
	}).resize();
});